import { generatePath, matchPath, NavigateFunction } from "react-router-dom";

import { SectionMenuOption } from "~/common/types";
import { ROUTES } from "../router";

export const getSessionMenuOptions = (
  navigate: NavigateFunction,
  patientId: string,
  sessionId: string,
  hasSoapNote = false,
  hasBillingNote = false,
  isFollowUpMeeting = false,
): SectionMenuOption[] => {
  const actualPath = window.location.pathname;

  const transcriptRoute = ROUTES.sessionDetailTranscript;
  const soapRoute = ROUTES.sessionDetailSoap;
  const billingRoute = ROUTES.sessionDetailBilling;

  const options: SectionMenuOption[] = [
    {
      label: "Transcript",
      onClick: () =>
        navigate(
          generatePath(transcriptRoute, {
            patientId,
            sessionId,
          }),
        ),
      current:
        !!matchPath(transcriptRoute, actualPath) ||
        !!matchPath({ path: ROUTES.sessionDetail, end: true }, actualPath),
      enable: true,
    },
  ];

  if (hasSoapNote && isFollowUpMeeting) {
    options.push({
      label: "SOAP note",
      onClick: () =>
        navigate(
          generatePath(soapRoute, {
            patientId,
            sessionId,
          }),
        ),
      current: !!matchPath(soapRoute, actualPath),
      enable: true,
    });
  }

  if (hasBillingNote && isFollowUpMeeting) {
    options.push({
      label: "Billing note",
      onClick: () =>
        navigate(
          generatePath(billingRoute, {
            patientId,
            sessionId,
          }),
        ),
      current: !!matchPath(billingRoute, actualPath),
      enable: true,
    });
  }

  return options;
};
